import { ShieldMoonIcon } from './ShieldMoonIcon';

/**
 * author: Michael Irigoyen
 * id 622FF7DE-FDD6-4831-9D3D-09157A5FC8AE
 * name shield-moon
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-moon.svg
 * tags
 * - Home Automation 
 */
export const AlarmArmNightIcon = ShieldMoonIcon;
export default AlarmArmNightIcon